export default __webpack_public_path__ + "static/media/mismatch-wrong-return.ed454473.png";